import {
  API_URL,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from '../../lib'
import {
  doBATCH_PARTICIPANT_TAG_LIST_REMOVE,
  doPROJECT_TAG_LIST_REMOVE,
  doREQUEST_COMPLETE,
  doREQUEST_ERROR,
} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_TAG_DELETE = 'REQUEST_PROJECT_TAG_DELETE'
export const doREQUEST_PROJECT_TAG_DELETE = createDoRequestAction(REQUEST_PROJECT_TAG_DELETE)

export const requestProjectTagDeleteActionCreators = {
  doREQUEST_PROJECT_TAG_DELETE,
}

export function* requestProjectTagDelete({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectTagDelete')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        tagIds: v.array().items(v.string().uuid().exist()).exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, tagIds} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'POST',
    url: `${API_URL}/v1/web/project-tag-delete`,
    accessToken,
    data: {
      projectId,
      tagIds,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-tag-delete',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doPROJECT_TAG_LIST_REMOVE({
      id: projectId,
      tagList: result.payload,
    }),
  )

  yield put(
    doBATCH_PARTICIPANT_TAG_LIST_REMOVE({
      projectId,
      tagIds: result.payload.map(({id}: any) => id),
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_TAG_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectTagDeleteSaga() {
  yield takeEvery(REQUEST_PROJECT_TAG_DELETE, requestProjectTagDelete)
}
